import { useLang } from '../../../i18n';
import './HeroSection.scss';

export default function HeroSection() {
  const { t } = useLang();

  return (
    <section className="contacts-hero">
      <div className="container contacts-hero__inner">
        <span className="eyebrow contacts-hero__eyebrow">{t('contacts.eyebrow')}</span>
        <h1 className="contacts-hero__title">{t('contacts.h1')}</h1>
        <p className="lead contacts-hero__lead">{t('contacts.lead')}</p>
      </div>
    </section>
  );
}
